"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, cloneElement } from "react";
import cx from "classnames";
const Loading = (props) => {
  const {
    className,
    prefix = "",
    children: child,
    text = "Loading\u2026",
    labelTransitions = false,
    labelPosition = "center",
    ...otherProps
  } = props;
  const baseClass = `${prefix}loading`;
  const [displayText, setDisplayText] = useState(text);
  const [fadeOut, setFadeOut] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  useEffect(() => {
    let fadeOutTimer;
    let fadeInTimer;
    if (labelTransitions && text !== displayText) {
      setFadeIn(false);
      setFadeOut(true);
      fadeOutTimer = setTimeout(() => {
        setFadeOut(false);
        fadeInTimer = setTimeout(() => {
          setFadeIn(true);
          setDisplayText(text);
        }, 100);
      }, 100);
    } else {
      setFadeIn(true);
      setDisplayText(text);
    }
    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(fadeInTimer);
    };
  }, [text]);
  const loadingClass = cx(
    baseClass,
    `${baseClass}--label-${labelPosition}`,
    className
  );
  const loadingTextClasses = cx(
    `${baseClass}__text`,
    fadeOut && `${baseClass}__text--fade-out`,
    fadeIn && `${baseClass}__text--fade-in`
  );
  const shouldRenderLabel = child && React.isValidElement(child) && !child.props.size || child && React.isValidElement(child) && child.props.size === "large";
  return /* @__PURE__ */ jsxs("span", { ...otherProps, className: loadingClass, "aria-live": "polite", children: [
    child && React.isValidElement(child) && cloneElement(child, { prefix }),
    shouldRenderLabel && /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: loadingTextClasses, children: displayText }),
    /* @__PURE__ */ jsx("span", { className: `${baseClass}__sr-only-text`, children: text })
  ] });
};
var Loading_default = Loading;
export {
  Loading_default as default
};
